import axios from 'axios'
import * as config from './config'
import { state } from './state'

function getBaseUrl() {
  const environment = state.get('environment')
  const isAbsolutePath = state.get('isAbsolutePath')
  const baseApiUrl = !isAbsolutePath
    ? config.dev.baseApiUrl.relative
    : config.dev.baseApiUrl.absolute[environment]
  return baseApiUrl
}

export const http = axios.create({
  baseURL: getBaseUrl(),
})

async function loadTranslations() {
  try {
    const url = 'translations/order4'
    const payload = (await http.get(url)).data
    return { status: 'success', payload }
  } catch (error) {
    return {
      status: 'error',
      payload: {
        fn: loadTranslations.name,
        error,
        message: error.message,
      },
    }
  }
}

async function loadPriceTable() {
  try {
    const url = 'plans/TAL/price-tables'
    const payload = (await http.get(url)).data
    return { status: 'success', payload }
  } catch (error) {
    return {
      status: 'error',
      payload: {
        fn: loadTranslations.name,
        error,
        message: error.message,
      },
    }
  }
}

export async function loadAll() {
  const [translations, priceTable] = await Promise.all([
    loadTranslations(),
    loadPriceTable(),
  ])

  const isSuccess = [translations, priceTable].every(
    ({ status }) => status === 'success'
  )

  if (isSuccess) {
    return {
      status: 'success',
      payload: {
        translations: translations.payload,
        priceTable: priceTable.payload,
      },
    }
  } else {
    return { status: 'error' }
  }
}
